import React, { useState,useEffect } from "react";
import { qiniuService } from "../../services/qiniu.service";
import { message, Upload, Button, Progress } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const PasteImage = (props) => {
  const [image, setImage] = useState(props.src); // 用于存储黏贴的图片
  const [uploading, setUploading] = useState(false); // 用于控制上传状态
  const [uploadProgress, setUploadProgress] = useState({}); // 用于存储上传进度

  // 当上传状态改变时，通知父组件
  useEffect(() => {
    props.onUploadStatusChange?.(uploading);
  }, [uploading, props.onUploadStatusChange]);

  // if (props.src) setImage()

  const uploadRequest = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      setUploading(true);
      const result = await qiniuService.uploadFile({
        file,
        onProgress: (progress) => {
          setUploadProgress((prev) => ({
            ...prev,
            [file.uid]: progress.percent,
          }));
          onProgress(progress);
        },
      });
      props.onSuccess?.(result);
      setImage(result.url); // 设置图片 URL
      onSuccess(result);
      setUploading(false); // 清空上传进度
      message.success("上传成功");
    } catch (error) {
      onError(error);
      setUploading(false); // 清空上传进度
      message.error(error.message || "上传失败");
    }
  };

  const handlePaste = (event) => {
    const clipboardItems = event.clipboardData.items;
    const item = clipboardItems[0]; // 获取剪贴板中的文件
    if (!item.type.startsWith("image/")) {
      message.error("请黏贴图片文件");
      return;
    }
    const file = item.getAsFile(); // 将剪贴板中的文件转换为 File 对象
    const imageUrl = URL.createObjectURL(file); // 创建图片的临时 URL
    setImage(imageUrl); // 设置图片 URL
    uploadRequest({
      file,
      onSuccess: () => URL.revokeObjectURL(imageUrl),
      onError: () => URL.revokeObjectURL(imageUrl),
      onProgress: () => URL.revokeObjectURL(imageUrl),
    }); // 上传图片并释放临时 URL
  };

  const clearImage = () => {
    setImage(null);
    props.onSuccess?.({
      url: null,
    });
  };

  return (
    <div
      style={{
        display: "inline-block",
        border: "1px dashed #ccc",
        padding: "10px 20px",
        textAlign: "center",
        width: "300px",
        position: "relative",
      }}
      onPaste={handlePaste} // 监听 paste 事件
    >
      <p>
        点击{image ? "重新上传" : "上传按钮"} / 在此区域按{" "}
        <strong>Ctrl+V</strong> 黏贴图片
      </p>
      <Upload
        customRequest={uploadRequest}
        showUploadList={false}
        accept="image/*"
      >
        {image ? (
          <div style={{ cursor: "pointer" }}>
            <img
              src={image}
              alt="上传图片"
              style={{ maxWidth: "100%", maxHeight: "200px" }}
            />
          </div>
        ) : (
          <Button icon={<UploadOutlined />}>上传图片</Button>
        )}
      </Upload>
      {Object.keys(uploadProgress).length > 0 &&
        uploadProgress[Object.keys(uploadProgress)[0]] < 100 && (
          <Progress
            percent={uploadProgress[Object.keys(uploadProgress)[0]]}
            style={{ marginTop: "8px" }}
          />
        )}
      {image && (
        <div
          style={{
            color: "red",
            cursor: "pointer"
          }}
          onClick={clearImage}
        >
          删除
        </div>
      )}
    </div>
  );
};

export default PasteImage;
